"use client"

/**
 * Matches iPhone Safari's status bar and bottom toolbar to the page's top and
 * bottom edge colours, and keeps theme-color in sync on phones
 * (lib/safari-edges.ts). Renders nothing.
 *
 * Zero cost for desktop and for first paint: the module is a separate chunk,
 * fetched only on touch devices, after the window `load` event.
 */
import { useEffect } from "react"

export function SafariEdges(): null {
    useEffect(() => {
        if (!window.matchMedia("(pointer: coarse)").matches) return
        let cleanup: (() => void) | undefined
        let cancelled = false
        const start = () => {
            void import("@/lib/safari-edges").then((m) => {
                if (!cancelled) cleanup = m.installSafariEdges()
            })
        }
        if (document.readyState === "complete") start()
        else window.addEventListener("load", start, { once: true })
        return () => {
            cancelled = true
            window.removeEventListener("load", start)
            cleanup?.()
        }
    }, [])
    return null
}
